<template>
  <span
    :style="{ color: color, 'font-size': size + 'px' }"
    class="uni-icons"
    :class="[customIcons, customIcons ? type : '']"
    @click="_onClick"
  >
    {{ icons[type] }}
  </span>
</template>

<script>
import icons from './icons.js'

/**
 * Icons 图标
 * @description 用于展示 icons 图标
 * @tutorial https://ext.dcloud.net.cn/plugin?id=28
 * @property {Number} size 图标大小
 * @property {String} type 图标图案，参考示例
 * @property {String} color 图标颜色
 * @event {Function} click 点击 Icon 触发事件
 */
export default {
  name: 'UniIcons',
  props: {
    type: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#333333'
    },
    size: {
      type: [Number, String],
      default: 16
    },
    customIcons: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      icons: icons
    }
  },
  methods: {
    _onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: uniicons;
  src: url('./uni.ttf') format('truetype');
}

.uni-icons {
  font-family: uniicons;
  text-decoration: none;
  text-align: center;
}
</style>
